import {
    FETCH_AGENT_SERVICES_REQUEST,
    FETCH_AGENT_SERVICES_SUCCESS,
    FETCH_AGENT_SERVICES_FAILURE,

    CREATE_AGENT_SERVICE_REQUEST,
    CREATE_AGENT_SERVICE_SUCCESS,
    CREATE_AGENT_SERVICE_FAILURE,

    UPDATE_AGENT_SERVICE_REQUEST,
    UPDATE_AGENT_SERVICE_SUCCESS,
    UPDATE_AGENT_SERVICE_FAILURE,

    DELETE_AGENT_SERVICE_REQUEST,
    DELETE_AGENT_SERVICE_SUCCESS,
    DELETE_AGENT_SERVICE_FAILURE,
} from "../actions/types";


const initialState = {

    services: [],

    loading: false,

    error: null,

    message: "",

};


const agentServiceReducer = (
    state = initialState,
    action
) => {

    switch (action.type) {



        case FETCH_AGENT_SERVICES_REQUEST:

            return {

                ...state,

                loading: true,

                error: null,

            };


        case FETCH_AGENT_SERVICES_SUCCESS:

            return {

                ...state,

                loading: false,

                services:
                    Array.isArray(
                        action.payload
                    )
                        ? action.payload
                        : [],

                message:
                    "Agent services loaded successfully",

            };


        case FETCH_AGENT_SERVICES_FAILURE:

            return {

                ...state,

                loading: false,

                error:
                    action.payload,

                services: [],

            };


        case CREATE_AGENT_SERVICE_REQUEST:

            return {

                ...state,

                loading: true,

                error: null,

            };


        case CREATE_AGENT_SERVICE_SUCCESS:

            return {

                ...state,

                loading: false,

                services: [
                    ...state.services,
                    action.payload,
                ],

                message:
                    "Agent service created successfully",

            };


        case CREATE_AGENT_SERVICE_FAILURE:

            return {

                ...state,

                loading: false,

                error:
                    action.payload,

            };



        case UPDATE_AGENT_SERVICE_REQUEST:

            return {

                ...state,

                loading: true,

                error: null,

            };


        case UPDATE_AGENT_SERVICE_SUCCESS:

            return {

                ...state,

                loading: false,

                services:
                    state.services.map(
                        (service) =>
                            service.service_id ===
                            action.payload.service_id
                                ? {
                                    ...service,
                                    ...action.payload,
                                }
                                : service
                    ),

                message:
                    "Agent service updated successfully",

            };


        case UPDATE_AGENT_SERVICE_FAILURE:

            return {

                ...state,

                loading: false,

                error:
                    action.payload,

            };


        case DELETE_AGENT_SERVICE_REQUEST:

            return {

                ...state,

                loading: true,

                error: null,

            };


        case DELETE_AGENT_SERVICE_SUCCESS:

            return {

                ...state,

                loading: false,

                services:
                    state.services.filter(
                        (service) =>
                            service.service_id !==
                            action.payload
                    ),

                message:
                    "Agent service deleted successfully",

            };


        case DELETE_AGENT_SERVICE_FAILURE:

            return {

                ...state,

                loading: false,

                error:
                    action.payload,

            };


        default:

            return state;

    }

};


export default agentServiceReducer;